import { Link } from "react-router-dom";

export default function TileSphereLogo({ subtle = false }) {
  return (
    <Link to="/" className="flex items-center gap-2.5 group" data-testid="tilesphere-logo">
      <div className="relative w-9 h-9">
        <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-orange-400 via-pink-500 to-fuchsia-600 group-hover:scale-110 transition-transform duration-300" />
        <div className="absolute inset-[3px] rounded-[9px] bg-black/40 backdrop-blur" />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-3 h-3 rounded-full bg-white/90 shadow-[0_0_20px_rgba(255,255,255,0.8)]" />
        </div>
      </div>
      <div className={`font-display font-black ${subtle ? "text-white/60" : "text-white"} text-lg tracking-tight`}>
        Tile<span className="bg-gradient-to-r from-orange-400 to-pink-400 bg-clip-text text-transparent">Sphere</span>
      </div>
    </Link>
  );
}
